export type AdminSessionClaims = {
  sessionId: string;
  sessionPolicy: "admin-v1";
  sessionExpiresAt: number;
};

// Used for browser behaviour only. The backend verifies the signed token and session.
export const getAdminSession = (
  token: string | null
): AdminSessionClaims | null => {
  try {
    const encoded = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const claims = JSON.parse(
      atob(encoded.padEnd(Math.ceil(encoded.length / 4) * 4, "="))
    );
    return claims.sessionPolicy === "admin-v1" &&
      typeof claims.sessionId === "string" &&
      typeof claims.sessionExpiresAt === "number"
      ? claims
      : null;
  } catch {
    return null;
  }
};

export const adminActivityKey = (id: string) => `adminSessionActivity:${id}`;
